module.exports = __webpack_public_path__ + "static/logo-43cd981ebb44470912be4f72dfd0422b.svg";